module.exports = __webpack_public_path__ + "img/ballstar-tablet-mobile.92f0266c.png";